<template>
    <div class="resultUpload">
        <div class="step">
            <el-upload
                    class="upload-demo"
                    ref="upload"
                    accept=".txt,.xls,.xlsx,.csv"
                    action="http://apitest.medinbd.com/v1/back/upload/"
                    :multiple="true"
                    :file-list="uploadFiles"
                    :on-change="loadJsonFromFile"
                    :auto-upload="false">
                <el-button slot="trigger" size="medium" type="primary">生化結果上傳</el-button>
                <el-button style="margin-left: 10px;" size="medium" type="success" @click="submitUpload">確認上傳
                </el-button>
                <div slot="tip" class="el-upload__tip">支持TXT文件、CSV文件和EXCEL文件上傳</div>
            </el-upload>
        </div>
    </div>
</template>

<script>
    import resultUpload from '../assets/js/resultUpload'

    export default {
        name: "resultUpload",
        ...resultUpload
    }
</script>
<style scoped>
    .resultUpload >>> .el-button--medium {
        /*padding: 0.1rem 0.2rem;*/
    }

    .resultUpload >>> .el-upload__tip {
        margin: 0.12rem 0 0.31rem 0;
    }

    .resultUpload >>> .el-upload-list {
        padding: 0.1rem 0;
        border-top: 0.01rem solid #F0F4F5;
    }

    .resultUpload >>> .el-upload {
        float: left;
        margin-right: 0.1rem;
        width: 1.5rem;
        display: block;
    }

    .resultUpload >>> .el-button {
        width: 1.5rem;
        height: 0.36rem;
        display: block;
    }

    .resultUpload >>> .el-button--primary {
        background: #6C87FF;
    }

    .resultUpload >>> .el-button--success {
        background: #18CE5E;
    }

    .resultUpload >>> .el-upload-list__item .el-icon-upload-success {
        color: #6C87FF;
    }

</style>

<style src="../assets/css/resultUpload.css" scoped>

</style>
